import PropTypes from 'prop-types';

const displayName = 'Panel';
const propTypes = {
  visible: PropTypes.bool,
  fullScreen: PropTypes.bool,
  onChange: PropTypes.func,
  overflowHeight: PropTypes.number,
  pullable: PropTypes.bool,
  swipeableViewsProps: PropTypes.bool,
};
const defaultProps = {
  visible: false,
  isSlider: false,
  pullable: true,
  overflowHeight: 0,
  swipeableViewsProps: false,
};

export default {
  displayName,
  propTypes,
  defaultProps,
};
